<div>
    <div class="flex items-baseline px-2">
        <fa-icon [icon]="filter" class="text-gray-300 mr-2"></fa-icon>
        <div class="flex flex-wrap items-baseline">
            <ng-container *ngFor="let facet of displayableFacets; trackBy: trackById; index as i">
                <div
                    class="bg-white border-2 rounded mr-4 mb-2 pr-1 py-1.5"
                    [ngClass]="{ 'border-primary-500': facet.isActive, 'border-gray-400': !facet.isActive }"
                >
                    <kbart-combo-box
                        [closeButton]='true'
                        [items]="facet.values"
                        [closeOnItemClick]="false"
                        (itemClick)="toggleFacetValueId(facet.id, $event.id)"
                        class="block min-w-[165px]"
                    >
                        <div kbartComboBoxLabel>
                            <div class="pl-3">{{ facet.name | titlecase }}</div>
                        </div>
                        <ng-template let-value="item" #comboBoxItem>
                            <a
                                [routerLink]="['./']"
                                [queryParams]="{ facets: toggleFacetValueId(facet.id, value.id), p: 1 }"
                                [queryParamsHandling]="'merge'"
                                [state]="{ noScroll: true }"
                                class="flex justify-between"
                            >
                                <kb-checkbox
                                    [isChecked]="value.isActive"
                                    [isDisabled]="value.count === 0"
                                    [label]="value.name"
                                >
                                </kb-checkbox>
                                <span
                                    class="inline-flex items-center px-2 py-0 rounded-full text-xs font-medium bg-gray-100 text-gray-600"
                                    >{{ value.count }}</span
                                >
                            </a>
                        </ng-template>
                    </kbart-combo-box>
                </div>
            </ng-container>
            <div
                class="bg-white border-2 rounded py-1.5 mr-4 mb-2"
                [ngClass]="{
                    'border-primary-500': activePriceRange$ | async,
                    'border-gray-400': !(activePriceRange$ | async)
                }"
            >
                <vsf-dropdown
                    [position]="['bottom-right', 'bottom-left']"
                    [closeOnTriggerClick]='true'
                    [closeOnItemClick]="false"
                    widthClass="w-80"
                    #dropdown="vsfDropdown"
                >
                    <div vsfDropdownTrigger class=''>
                        <button
                            class=" min-w-[165px] group flex w-full justify-between text-sm font-medium text-gray-600 hover:text-gray-900"
                        >
                            <div class="mr-1 px-3">
                                <span>Price range</span>
                            </div>
                            <fa-icon [icon]="chevronDown" class="text-gray-500 pr-1"></fa-icon>
                        </button>
                    </div>
                    <div class="p-2" vsfDropdownContent>
                        <kb-price-range-inputs
                            (rangeChange)="setPriceRange($event); dropdown.close()"
                            [min]="min$ | async"
                            [max]="max$ | async"
                        >
                        </kb-price-range-inputs>
                    </div>
                </vsf-dropdown>
            </div>
            <button *ngIf="allFacets.length > displayableFacets.length" class="btn-icon" (click)="showAll()">
                <span class="mr-1">Show all filters</span>
                <fa-icon [icon]="arrowRight"></fa-icon>
            </button>
            <button *ngIf="showAllFacets" class="btn-icon" (click)="showFeatured()">
                <span class="mr-1">Show less</span>
                <fa-icon [icon]="arrowLeft"></fa-icon>
            </button>
        </div>
    </div>
</div>
